import styled from 'styled-components';

export const DialogBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-size: 13px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.onSurfaceVariant};
`;

export const Levels = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const Explanation = styled.p`
  margin: 0;
  font-size: 14px;
`;

export const LinkRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

export const LinkBox = styled.code`
  flex: 1 1 auto;
  min-width: 0;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.outlineVariant};
  background: ${({ theme }) => theme.colors.surfaceContainerHigh};
  color: ${({ theme }) => theme.colors.onSurface};
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  user-select: all;
`;

export const ProblemList = styled.ul`
  margin: 0;
  padding-left: 18px;
`;

export const Actions = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;
